var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2600_40462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3332C5.39758 18.3332 1.66675 14.6023 1.66675 9.99984C1.66675 5.39734 5.39758 1.6665 10.0001 1.6665C14.6026 1.6665 18.3334 5.39734 18.3334 9.99984C18.3334 14.6023 14.6026 18.3332 10.0001 18.3332ZM10.0001 16.6665C11.7682 16.6665 13.4639 15.9641 14.7141 14.7139C15.9644 13.4636 16.6667 11.7679 16.6667 9.99984C16.6667 8.23173 15.9644 6.53603 14.7141 5.28579C13.4639 4.03555 11.7682 3.33317 10.0001 3.33317C8.23197 3.33317 6.53628 4.03555 5.28604 5.28579C4.03579 6.53603 3.33341 8.23173 3.33341 9.99984C3.33341 11.7679 4.03579 13.4636 5.28604 14.7139C6.53628 15.9641 8.23197 16.6665 10.0001 16.6665ZM10.8334 9.99984H14.1667V11.6665H9.16675V5.83317H10.8334V9.99984Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_40462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.1cad9759f5dfdf5c0ffce8eb06844e4b.svg";
export { ForwardRef as ReactComponent };